module.exports = __webpack_public_path__ + "static/media/instagram.6874775a.png";